import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRemoved = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#B3261E",
		d: "M3.726 8.94 6 6.665l2.274 2.273.665-.665L6.666 6l2.273-2.274-.665-.665L6 5.334 3.726 3.061l-.665.665L5.334 6 3.061 8.274l.665.665ZM6.001 12c-.83 0-1.61-.158-2.34-.472a6.061 6.061 0 0 1-1.906-1.283A6.06 6.06 0 0 1 .473 8.341 5.84 5.84 0 0 1 0 6c0-.83.157-1.61.472-2.34a6.06 6.06 0 0 1 1.283-1.906A6.06 6.06 0 0 1 3.659.473 5.84 5.84 0 0 1 6 0c.83 0 1.61.157 2.34.472a6.06 6.06 0 0 1 1.905 1.283c.54.54.968 1.174 1.283 1.904.316.73.473 1.51.473 2.34 0 .83-.158 1.61-.472 2.34a6.06 6.06 0 0 1-1.283 1.905c-.54.54-1.174.968-1.904 1.283C7.61 11.843 6.83 12 6 12Z"
	})
});
export { SvgRemoved as ReactComponent };
